<template>
  <div class="classCell-box">
    <router-link :to="{ name: 'ClassInfo', query: { 'course': course.id }}" class="class-a">
    <div>
      <div class="classCell-title">{{course.name}}</div>
      <!-- <div class="classCell-subtitle">班級編號: {{course.code}}</div> -->
      <div class="classCell-context">
        <div>班級人數: {{course.noOfStudent}}</div>
      </div>
    </div>
    </router-link>
  </div>
</template>
<style type="text/css" scoped>
.classCell-box{
  background-color: #397f1f;
  border-radius: 0.5rem;
  height: 12rem;
  width: 20rem;
  display:flex;
  align-items:center;
  justify-content:center;
  margin: 1rem;
}
.class-a:hover{
  text-decoration-color: white !important;
}
.classCell-title{
  color: white;
  font-size: 1.5rem;
  text-align: center;
}
.classCell-subtitle{
  color: white;
  font-size: 1rem;
  padding-top: 0.3rem;
  text-align: center;
}

.classCell-context{
  color: white;
  font-size: 1rem;
  padding-top:1.3rem;
  text-align: center;
}
@media screen and (max-width: 790px) {
  .classCell-box{
    margin: 1rem auto;
  }
}
</style>
<script>
export default {
  props: {
    course: Object
    // id: Number,
    // name: String,
    // noOfStudent: Number
  }
}
</script>
